import React, { Component } from 'react';

function BookingFailure() {
  return (
    <div className="pb-payment-details-booking-failure">
      Component content: pb-payment-details/BookingFailure
    </div>
  );
}

export default BookingFailure;

// OLD COMPONENT BASED CODE

// export default class BookingFailure extends Component {
//   static propTypes = {};

//   render() {
//     return (
//       <div className="pb-payment-details-booking-failure">
//         Component content: pb-payment-details/BookingFailure
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/BookingFailure/BookingFailure.js